<script lang="ts">
  import '@df/ui/fonts';
  import '../styles/carbon.css';
  import '../styles/chrome.css';
  import '../styles/global.css';
  import '../styles/layer_order.css';
  import '../styles/tokens.css';
  import '../styles/ui.css';
  import '../styles/typography_legacy.css';

  import { ledgerWorker } from '$stores/sie';
  import { terminateWorkers } from '$workers/index';
  import { Theme } from 'carbon-components-svelte';
  import { onDestroy, onMount, type Snippet } from 'svelte';
  import { setInsideModalContext } from '$lib/inside_modal_context';

  interface Props {
    children: Snippet;
  }

  const { children }: Props = $props();

  onMount(async () => {
    const [sieWorker] = await Promise.all([import('$workers/sie.worker?worker')]);
    $ledgerWorker = new sieWorker.default();
  });

  setInsideModalContext(false);

  onDestroy(() => {
    terminateWorkers($ledgerWorker);
  });
</script>

{@render children()}

<Theme
  theme="white"
  tokens={{
    // Blue 60
    'background-brand': '#288375',
    'border-interactive': '#288375',
    'link-primary': '#288375',
    'icon-interactive': '#288375',
    'button-primary': '#288375',
    'button-tertiary': '#288375',
    focus: '#288375',
    interactive: '#288375',
    'interactive-01': '#288375',
    'interactive-03': '#288375',
    'interactive-04': '#288375',
    'link-01': '#288375',
    'brand-01': '#288375',
    'brand-03': '#288375',
    // Blue 70
    'link-02': '#247669',
    'hover-primary-text': '#247669',
    'link-secondary': '#247669',
    'link-primary-hover': '#247669',
    // Blue 60 hover
    'hover-tertiary': '#267C6F',
    'button-primary-hover': '#267C6F',
    'button-tertiary-hover': '#267C6F',
    // Blue 80
    'hover-primary': '#20695E',
    'active-primary': '#20695E',
    'active-tertiary': '#20695E',
    'button-primary-active': '#20695E',
    'button-tertiary-active': '#20695E',
    // Blue 40
    'inverse-link': '#38B7A3',
    'link-inverse': '#38B7A3',
    // Blue 20
    highlight: '#CBEFEA',
    'interactive-02': '#333333',
    'ui-05': '#333333',
    // Support error colors reverse
    'text-error': '#fa4d56',
    'support-01': '#fa4d56',
    'danger-01': '#fa4d56',
    'danger-02': '#fa4d56',
    'support-error': '#fa4d56',
    'button-danger-primary': '#fa4d56',
    'button-danger-secondary': '#fa4d56',
    'button-danger-hover': '#fa4d56', // MAYBE THIS???
    danger: '#fa4d56',
    'inverse-support-01': '#da1e28',
    'support-error-inverse': '#da1e28',
    'support-02': '#42be65',
    'support-success': '#42be65',
    'inverse-support-02': '#19804E',
    'support-success-inverse': '#19804E',
    'support-04': '#4589ff',
    'support-info': '#4589ff',
    'inverse-support-04': '#0043ce',
    'support-info-inverse': '#0043ce',
  }}
/>

<!-- TODO#4547
{#if environment === 'testing'}
  <div class="staging-banner">
    🚧 Detta är en Testmiljö. Tillgängligheten kan variera. Vi rensar data regelbundet ...
  </div>
{/if}
-->

<!-- This allows the action teleport in lib to spawn things outside of the tree, and with highest stacking (unless z-index on the same level is used to override) -->
<div id="teleport-container"></div>

<style>
  :global(*) {
    --diffinder-brand: #288375;
  }

  :global(.bx--progress-step) {
    width: 100%;
    min-width: unset;
  }
</style>
